import React from "react";

import { PhaseSummary as PhaseSummaryComponent } from "heat-next";

import { useSessionDetailsContext } from "@/context/session-details/session-details";

import { ComponentWrapper } from "@/pages/shared/shared.styles";

import ContentLoader from "@/components/content-loader/content-loader";
import EmptyState from "@/components/empty-state/empty-state";
import { EmptyStateType } from "@/components/empty-state/empty-state.types";

import { PhaseSummaryWrapper } from "./phase-summary.styles";

const PhaseSummary: React.FC = () => {
    const { phaseSummaryData, isFetchingPhaseSummary, isErrorPhaseSummary } =
        useSessionDetailsContext();

    const isEmptyState =
        !phaseSummaryData || (Array.isArray(phaseSummaryData) && phaseSummaryData.length === 0);

    if (isFetchingPhaseSummary) {
        return <ContentLoader height="15.5rem" />;
    }

    if (isErrorPhaseSummary) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="error-state:title"
                    description="error-state:description"
                    emptyStateType={EmptyStateType.Error}
                    minHeight="15.5rem"
                />
            </ComponentWrapper>
        );
    }

    if (isEmptyState) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="session-details:phase-summary:empty-state:title"
                    emptyStateType={EmptyStateType.Charts}
                    minHeight="15.5rem"
                />
            </ComponentWrapper>
        );
    }

    if (Array.isArray(phaseSummaryData)) {
        const phases = phaseSummaryData.flat();

        return (
            <PhaseSummaryWrapper>
                {phases.map((phase: any, index: number) => (
                    <PhaseSummaryComponent key={phase.title || index} data={phase} defaultOpen />
                ))}
            </PhaseSummaryWrapper>
        );
    }

    return <PhaseSummaryComponent data={phaseSummaryData} defaultOpen />;
};

export default PhaseSummary;
